// Сессия игрока: контракт эндпоинтов /api/session.
// Структуры повторяют записи бэкенда в src/Backend/Game/SessionState.cs.
//
// Сессия держит счёт игрока, его ставку и состояние фич между раундами. Открытый бонусный
// барабан и заряд манометра переживают раунд, поэтому фича без сессии не играется, см. GDD,
// раздел 5.
//
// Деньги считает бэкенд, см. ADR-09. Клиент берёт счёт отсюда и показывает его, своего счёта
// он не ведёт.

import type { Cents } from './gameConfig';
import { getJson, postJson } from './http';

const SESSION_URL = '/api/session';

/** Стадия 1: wild открывает бонусные барабаны, множителей ещё нет. */
export const STAGE_ONE: number = 1;

/** Стадия 2: вместо wild выпадает wild multiplier, манометры заряжаются. */
export const STAGE_TWO: number = 2;

/** Хранимое состояние фичи Steam Spin. */
export interface SteamSpinState {
  /** Стадия фичи: 1 или 2. Стадия 1 идёт с начала игры, см. GDD, раздел 5.1. */
  readonly stage: number;

  /** Открыт ли каждый бонусный барабан слева направо. */
  readonly opened: readonly boolean[];

  /** Заряд каждого манометра слева направо, от нуля до потолка. */
  readonly gauges: readonly number[];

  /** Позиция остановки каждой бонусной полосы: индекс символа в верхнем ряду. */
  readonly stops: readonly number[];
}

/** Состояние игрока между раундами: счёт, ставка и надстройки. */
export interface SessionState {
  /** Состояние фичи Steam Spin. Нет поля — в этом слоте фичи нет. */
  readonly steamSpin?: SteamSpinState;

  /** Счёт игрока. */
  readonly balance: Cents;

  /** Ставка, которой игрок сыграл прошлый раунд. С неё начинается следующий. */
  readonly stake: Cents;
}

/** Сессия: её номер, счёт, ставка, состояние надстроек и возможности текущего режима. */
export interface SessionSnapshot {
  readonly id: string;
  readonly state: SessionState;

  /** Разрешены ли кнопки запуска бонусов в демонстрационном режиме. */
  readonly demoCheats: boolean;
}

/** Заводит сессию на бэкенде. Клиент делает это один раз, на загрузке. */
export function openSession(): Promise<SessionSnapshot> {
  return postJson<SessionSnapshot>(SESSION_URL);
}

/** Читает состояние сессии с бэкенда. */
export function fetchSession(id: string): Promise<SessionSnapshot> {
  return getJson<SessionSnapshot>(`${SESSION_URL}/${id}`);
}
